import React, { Component } from "react";
import clsx from "clsx";

class ToolsNotice extends Component {
	render() {
		const { tone, icon, title, detail, isCentered, action, className, children } = this.props;

		const noticeClasses = clsx("tk-notice", tone && `tk-notice--${tone}`, isCentered && "tk-notice--center", className);

		return (
			<div className={noticeClasses}>
				<div className="tk-notice__row">
					{icon && <span className="tk-notice__icon">{icon}</span>}
					<div className="tk-notice__main">
						{title && <div className="tk-notice__title">{title}</div>}
						{detail && <div className="tk-notice__detail">{detail}</div>}
						{children}
					</div>
					{action}
				</div>
			</div>
		);
	}
}

export default ToolsNotice;
